export default "<button>\r\n  <ng-content></ng-content>\r\n</button>";